import { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import BuildingIcon from '@/components/Icons/BuildingIcon';
import { Chip, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const AgencyChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 12,
  '& .building-icon': {
    margin: '0 -8px -2px 10px',
    color: theme.palette.success.dark,
    width: 13,
  },
}));

const AgencyCell = ({ value }: GridRenderCellParams<IAdvertiserGridRow>) => {
  return (
    <div className='overflow-hidden'>
      {value ? <AgencyChip icon={<BuildingIcon />} variant='outlined' label={value?.label} /> : '-'}
    </div>
  );
};

export default AgencyCell;
